export const landings = [
  {
    name: "Apollo 11",
    lat: 0.674,
    lng: 23.473,
    launchDate: "16-07-1969",
    landingDate: "20-07-1969",
    landingSite: "Mare Tranquilitatis",
    traverse: 0.25,
    sampleReturn: "21.55kg",
    evaTime: 2.53,
    siteLink: "https://www.nasa.gov/mission_pages/apollo/missions/apollo11.html"
  },
  {
    name: "Apollo 12",
    lat: 3.013,
    lng: 23.442,
    launchDate: "14-11-1969",
    landingDate: "19-11-1969",
    landingSite: "Oceanus Procellarum",
    traverse: 1.35,
    sampleReturn: "34.35kg",
    evaTime: 7.75,
    siteLink: "https://www.nasa.gov/mission_pages/apollo/missions/apollo12.html"
  },
  {
    name: "Apollo 14",
    lat: 3.646,
    lng: 17.472,
    launchDate: "31-01-1971",
    landingDate: "05-02-1971",
    landingSite: "Fra Mauro",
    traverse: 3.45,
    sampleReturn: "42.28kg",
    evaTime: 9.38,
    siteLink: "https://www.nasa.gov/mission_pages/apollo/missions/apollo14.html"
  },
  {
    name: "Apollo 15",
    lat: 26.132,
    lng: 3.633,
    launchDate: "26-07-1971",
    landingDate: "30-07-1971",
    landingSite: "Hadley Rille",
    traverse: 27.9,
    sampleReturn: "77.31kg",
    evaTime: 9.13,
    siteLink: "https://www.nasa.gov/mission_pages/apollo/missions/apollo15.html"
  },
  {
    name: "Apollo 16",
    lat: 8.973,
    lng: 15.501,
    launchDate: "16-04-1972",
    landingDate: "20-04-1972",
    landingSite: "Descartes",
    traverse: 27.0,
    sampleReturn: "95.71kg",
    evaTime: 0.23,
    siteLink: "https://www.nasa.gov/mission_pages/apollo/missions/apollo16.html"
  },
  {
    name: "Apollo 17",
    lat: 20.191,
    lng: 30.772,
    launchDate: "07-12-1972",
    landingDate: "11-12-1972",
    landingSite: "Taurus-Lttrow",
    traverse: 35.0,
    sampleReturn: "110.52kg",
    evaTime: 2.07,
    siteLink: "https://www.nasa.gov/mission_pages/apollo/missions/apollo17.html"
  }
]